module.exports = __webpack_public_path__ + "img/angle-down.d6b936d9.svg";